import { TableProps } from 'antd/es/table';

import { Status } from '@Components/Base';

export const mapColumns: TableProps['columns'] = [
  {
    title: 'REQUEST NO.',
    dataIndex: 'requestNo',
    key: 'requestId',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'EMP NUMBER',
    dataIndex: 'empNumber',
    key: 'empNumber',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'EMP NAME',
    dataIndex: 'empName',
    key: 'empName',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'RESIGNATION DATE',
    dataIndex: 'resignationDate',
    key: 'resDate',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'LAST WORKING DATE',
    dataIndex: 'lastWorkingDate',
    key: 'lastWrkngDate',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'LETTER OF CONTENT',
    dataIndex: 'letterOfContent',
    key: 'letterContent',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REASON',
    dataIndex: 'reason',
    key: 'reason',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'CREATION DATE',
    dataIndex: 'createdDate',
    key: 'createdDate',
    sorter: true,
    ellipsis: true,
  },

  {
    title: 'APPROVER NAME',
    dataIndex: 'approverName',
    key: 'approverName',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'STATUS',
    dataIndex: 'status',
    key: 'statusId',
    sorter: true,
    render: (text) => <Status text={text} />,
  },
];
